export default function () {
  /* 门店列表表格列头 */
  return [
    {
      label: "序号",
      type: "index",
      width: 80
    },
    {
      label: "门店名称",
      prop: "store_name",
      width: 150
    },
    {
      label: "老板姓名",
      prop: "boss_name",
      width: 120
    },
    {
      label: "门店电话",
      prop: "store_phone",
      width: 130
    },
    {
      label: "门店地址",
      prop: "store_addr",
      minWidth: 200
    },
    {
      label: "工作时间",
      prop: "workTime",
      width: 150
    },
    {
      label: "状态",
      prop: "status",
      slots: "status",
      width: 100
    },
    {
      label: "操作",
      prop: "operation",
      width: 150,
      slots: "operation",
      fixed: "right"
    }
  ];
}
